<div class="create-team-form">
  <h2>Crea un nuovo team</h2>
  <form (ngSubmit)="createTeam()">
    <label for="teamName">Nome team:</label>
    <input
      id="teamName"
      name="teamName"
      type="text"
      [(ngModel)]="teamName"
      required
      autocomplete="off"
    />
    <button type="submit">Crea</button>
  </form>
  <div class="message" *ngIf="message">{{ message }}</div>
</div>